import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MetaFieldService } from '../../../core/services/meta-field.service';
import { MetaFieldDto } from '../../../core/models/meta-field.model';
import { MetaService } from '../../../core/services/meta.service';
import { Observable } from 'rxjs';


@Component({
      selector: 'app-meta-field',
      standalone: true, // Assuming Angular 19/20 setup
      imports: [CommonModule, FormsModule],
      templateUrl: './meta-field.component.html'
})
export class MetaFieldComponent implements OnInit {
      list: MetaFieldDto[] = []; // Use the DTO type instead of any
      total: number = 0;
      entities: any[] = [];
      pageIndex: number = 0;
      pageSize: number = 5;
      searchTerm: string = '';

      isModalOpen = false;
      isEditMode = false;

      // Initialize form with DTO structure
      form: Partial<MetaFieldDto> = this.getEmptyForm();

      constructor(private metaService: MetaFieldService, private service: MetaService) { } // Inject Service, not HttpClient

      ngOnInit(): void {
            this.loadData();
            this.loadEntities(); // Load these for the dropdown
      }

      loadData() {
            this.metaService.getAll(this.pageIndex, this.pageSize, this.searchTerm)
                  .subscribe({
                        next: (res) => {
                              this.list = res.data;
                              this.total = res.totalRecords;
                        },
                        error: (err) => console.error('Load failed', err)
                  });
      }

      // loadEntities(): void {
      //       // We pass the search term directly to the API
      //       this.service.getAll(this.pageIndex, this.pageSize, this.searchTerm).subscribe({
      //             next: (res: any) => {
      //                   this.entities = res.items;
      //                   this.total = res.totalCount;
      //             },
      //             error: (err) => console.error('Load Error', err)
      //       });
      // }
      loadEntities(): void {
            this.service.getAllEntities().subscribe({
                  next: (res: any[]) => {
                        // Since the API returns a direct array [...], just assign it directly!
                        // No need for res.items or res.totalCount anymore.
                        this.entities = res;
                  },
                  error: (err) => {
                        console.error('Failed to load entities', err);
                  }
            });
      }
      applyFilter() {
            this.pageIndex = 0;
            this.loadData();
      }

      goToPage(index: number) {
            if (index >= 0 && index < this.total) {
                  this.pageIndex = index;
                  this.loadData();
            }
      }

      changePageSize(event: any) {
            this.pageSize = +event.target.value;
            this.pageIndex = 0;
            this.loadData();
      }

      openCreateModal() {
            this.isEditMode = false;
            this.form = this.getEmptyForm();
            this.isModalOpen = true;
      }

      // openEditModal(item: MetaFieldDto) {
      //       this.isEditMode = true;
      //       this.form = { ...item }; // Clone the object
      //       this.isModalOpen = true;
      // }
      openEditModal(item: MetaFieldDto) {
            this.isEditMode = true;
            // Ensure the entityId property is set so the dropdown can find the match
            this.form = {
                  ...item,
                  entityId: item.entityId // Ensure this property exists on your item
            };
            this.isModalOpen = true;
      }

      closeModal() {
            this.isModalOpen = false;
      }

      save() {
            // NEW: Validation Guard
            if (!this.form.entityId || this.form.entityId === '') {
                  alert("Selection Required: Please choose a valid Entity from the dropdown.");
                  return;
            }
            // 1. Define JSONB fields (PascalCase for DTO)
            const jsonFields = [
                  'Options', 'DataSource', 'Events', 'Reference',
                  'Visibility', 'SoftMax', 'DependsOn', 'State'
            ];

            // 2. Initialize payload with explicit 'any' to allow dynamic string indexing
            const payload: any = {
                  Id: this.form.id || crypto.randomUUID(),
                  EntityId: this.form.entityId,
                  FieldId: this.form.fieldId,
                  Name: this.form.name,
                  Label: this.form.label,
                  Type: this.form.type || 'text',
                  Category: this.form.category || 'dynamic',
                  ParentField: this.form.parentField,
                  IsRequired: !!this.form.isRequired,
                  InputType: this.form.inputType,
                  Placeholder: this.form.placeholder,
                  ComputedExpression: this.form.computedExpression,
                  DisplaySource: this.form.displaySource,
                  RequiredWhen: this.form.requiredWhen,
                  Seq: this.form.seq || 0
            };

            // 3. Loop through JSON fields using safe indexing
            jsonFields.forEach(field => {
                  const camelKey = (field.charAt(0).toLowerCase() + field.slice(1)) as keyof any;
                  // Use type assertion to bypass indexing error TS7053
                  const value = (this.form as any)[camelKey];

                  if (value !== undefined && value !== null && value !== '') {
                        if (typeof value !== 'string') {
                              payload[field] = JSON.stringify(value);
                        } else {
                              try {
                                    JSON.parse(value);
                                    payload[field] = value;
                              } catch (e) {
                                    payload[field] = JSON.stringify(value);
                              }
                        }
                  } else {
                        payload[field] = null;
                  }
            });

            // 4. Handle Observable mismatch by casting to Observable<any> (Fixes TS2349)
            const request$ = (this.isEditMode
                  ? this.metaService.update(payload.Id, payload)
                  : this.metaService.create(payload)) as Observable<any>;

            request$.subscribe({
                  next: () => {
                        this.loadData();
                        this.closeModal();
                  },
                  // Explicitly type 'err' to satisfy TS7006
                  error: (err: any) => {
                        console.error("SWERP Save Error:", err);
                        alert("Error: Check console for details.");
                  }
            });
      }
      delete(id: string) {
            if (confirm('Are you sure you want to delete this field?')) {
                  this.metaService.delete(id).subscribe(() => this.loadData());
            }
      }

      // private getEmptyForm(): Partial<MetaFieldDto> {
      //       return {
      //             id: '00000000-0000-0000-0000-000000000000',
      //             type: 'text',
      //             category: 'dynamic',
      //             isRequired: false,
      //             seq: 0
      //       };
      // }
      private getEmptyForm(): Partial<MetaFieldDto> {
            return {
                  id: '00000000-0000-0000-0000-000000000000',
                  entityId: '',
                  fieldId: '',
                  name: '',
                  label: '',
                  type: 'text',
                  category: 'static',
                  entityName: '',
                  parentField: null,
                  isRequired: false,
                  inputType: 'text',
                  placeholder: '',
                  options: null,
                  dataSource: null,
                  events: null,
                  reference: null,
                  visibility: 'visible',
                  softMax: null,
                  dependsOn: null,
                  state: null,
                  computedExpression: null,
                  displaySource: null,
                  requiredWhen: null,
                  seq: 0
            };
      }
}